import { render } from "./ChartCompanyMixins.vue?vue&type=template&id=06c96038"
import script from "./ChartCompanyMixins.vue?vue&type=script&lang=js"
export * from "./ChartCompanyMixins.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__